__webpack_require__.p = "/combat/";